import React from 'react';
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}
export function Checkbox({
  label,
  className = '',
  ...props
}: CheckboxProps) {
  return <label className="flex items-center cursor-pointer" data-id="element-243">
      <input type="checkbox" className={`w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer ${className}`} {...props} data-id="element-244" />
      {label && <span className="ml-2 text-sm text-gray-700" data-id="element-245">{label}</span>}
    </label>;
}